export default function CsharpDataTypes() {
  return (
    <h2>Csharp Data Types</h2>
  );
}
